// 积分上下级关系绑定逻辑
import { appUser } from '@/utils'
import {
  setCookie, getCookie, delCookie
} from '@/utils/common/cookie';
export const bindUserReferrer = (store) => {
  // 测试环境绑定关系
  // const shareUserSrc = getCookie('shareUserSrc') || '';
  // if (shareUserSrc.indexOf('test') >= 0) {
  //   delCookie('userReferrer');
  //   delCookie('bindSuccess');
  //   delCookie('unLoginReferrer');
  // }
  let { userReferrer } = store.state.args; // 获取url里的 分享人信息
  const userId = appUser.userId || null;
  if (!userId && userReferrer) setCookie('unLoginReferrer', userReferrer, 30); // 未登录时缓存URL里的推荐人信息
  // goods-camp页面 涉及到  shareCode接口解密返回URL  导致分享人信息丢失  so 从缓存获取分享人信息
  if (!userReferrer) userReferrer = getCookie('unLoginReferrer');
  if (appUser.isNative || !userId) return
  if (!userReferrer) return
  const localUserReferrer = getCookie('bindSuccess') // 上次接收的推荐人信息
  const bindSuccessTime = getCookie('bindSuccessTime')
  if (localUserReferrer) return console.log('上次绑定时间:', bindSuccessTime);
  store.dispatch('integral/index/inviteBind', { inviteUserId: userReferrer }).then(() => {
    setCookie('userReferrer', userReferrer, 30);
    setCookie('shareUserSrc', window.location.href, 30);
    setCookie('bindSuccess', userReferrer, 30); //
    setCookie('bindSuccessTime', JSON.stringify(new Date().toFormattedString('yyyy-MM-dd hh:mm:ss')));
    delCookie('unLoginReferrer')
  }).catch(err => {
    setCookie('bindFail', (JSON.stringify(err)))
    localStorage.setItem('bindFail', JSON.stringify(err))
  })
}